import React from "react";

const MengasahLogikaAIObstacle: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">
                🤖 Robot Otonom dan Pengambilan Keputusan Berbasis AI
            </h2>

            <p className="mb-4">
                Kemampuan robot untuk mengambil keputusan secara mandiri merupakan salah satu ciri utama teknologi kecerdasan buatan modern. Seiring berkembangnya pembelajaran robotik, berbagai program edukasi dan kompetisi mulai memperkenalkan konsep robot otonom kepada generasi muda melalui pendekatan praktik langsung.
            </p>

            <p className="mb-4">
                Sejumlah lembaga dan organisasi yang aktif dalam pengembangan robotik antara lain{' '}
                <a
                    href="https://iyra-indonesia.id/"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    IYRA Indonesia
                </a>
                , yang secara konsisten mendorong pembelajaran teknologi dan kompetisi robotik sebagai bagian dari persiapan talenta digital masa depan.
            </p>

            <h3 className="text-md font-semibold mb-2">
                ⚙️ Obstacle Avoidance Driving Robot Game
            </h3>

            <p className="mb-4">
                Dalam konteks tersebut, Lomba Obstacle Avoidance Driving Robot Game menjadi ajang yang relevan karena menantang peserta untuk menyusun logika pemrograman yang memungkinkan robot mendeteksi rintangan dan menentukan jalur terbaik secara otomatis.
            </p>

            <p className="mb-4">
                Peserta harus mengatur bagaimana data dari berbagai sensor diterjemahkan menjadi perintah gerak yang akurat dan responsif, mulai dari pengaturan jarak, arah, hingga kecepatan robot. Proses pengujian dan evaluasi menjadi bagian penting untuk memastikan sistem robot dapat bekerja secara stabil dan optimal.
            </p>

            <h3 className="text-md font-semibold mb-2">
                🏆 Prestasi dan Pembelajaran Robotik di Sekolah
            </h3>

            <p className="mb-4">
                Penerapan konsep serupa juga terlihat pada kompetisi robotik tingkat sekolah. Tim robotik <strong>SMA Labschool Unesa</strong> berhasil mewakili Indonesia dalam kompetisi robotik internasional setelah meraih prestasi pada{' '}
                <a
                    href="https://en.unesa.ac.id/keren-tim-robotika-sma-labschool-unesa-wakili-indonesia-dalam-kompetisi-internasional-di-jeddah"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    National Robotics Championship (IRTC)
                </a>
                .
            </p>

            <p className="mb-4">
                Kompetisi ini menilai kemampuan robot dalam bergerak, navigasi, dan pengendalian otomatis, serta menunjukkan bahwa pembelajaran robotik berbasis praktik mampu membangun kemampuan problem solving dan logika sistem sejak usia sekolah.
            </p>

            <h3 className="text-md font-semibold mb-2">
                🚀 Dukungan Talenta Digital dan STEM
            </h3>

            <p className="mb-4">
                Pendekatan pembelajaran seperti ini sejalan dengan meningkatnya perhatian terhadap ekskul robot yang kerap disebut sebagai salah satu kegiatan yang diminati dan didorong dalam wacana pengembangan talenta muda. Dukungan terhadap penguatan keterampilan robotik dan STEM juga diperkuat oleh berbagai platform edukasi, salah satunya AEDU (Accelist Edukasi).
            </p>

            <p className="mb-4">
                Informasi lengkap mengenai program AEDU dapat diakses melalui{' '}
                <a
                    href="https://edukasi.accelist.com/"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    website AEDU
                </a>.
            </p>

            <p className="text-gray-700">
                Melalui kompetisi yang dihadirkan oleh <strong>IIT</strong>, Obstacle Avoidance Driving Robot Game menjadi sarana pembelajaran yang selaras dengan perkembangan teknologi saat ini. IIT tidak hanya memperkenalkan dasar robotik, tetapi juga membekali peserta dengan pemahaman pengambilan keputusan cerdas yang menjadi fondasi berbagai inovasi berbasis kecerdasan buatan di masa depan.
            </p>

            <p className="mt-4 font-semibold">
                👉 Cek informasi{' '}
                <a
                    href="/iit-program?program=ObstacleDriving"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                >
                    Obstacle Avoidance Driving Robot Game
                </a>{' '}
                lebih lanjut
            </p>
        </div>
    );
};

export default MengasahLogikaAIObstacle;
